import { getOrCreateAudio } from '@cp/ds/src/utils/audio';
import messageSound from '../assets/message.mp3';

let isUnlocked = false;

const ignoreAutoplayRestriction = (): void => {
  // Browser may block audio until the user interacts with the page.
};

export const unlockNotificationAudio = (): void => {
  if (isUnlocked) {
    return;
  }

  const audio = getOrCreateAudio(messageSound);
  audio
    .play()
    .then(() => {
      audio.pause();
      audio.currentTime = 0;
      isUnlocked = true;
    })
    .catch(ignoreAutoplayRestriction);
};

export const playNotificationSound = (): void => {
  const audio = getOrCreateAudio(messageSound);
  audio.currentTime = 0;
  audio.play().catch(ignoreAutoplayRestriction);
};
